import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import PageNotFound from '~/commons/components/PageNotFound.jsx';
import {
  Nav,
} from './layout';
import {
  RouteArticles,
  RouteSchools,
  RouteUsers,
  RouteDashboards,
  RouteReports,
} from './routes';

const SchoolAdmin = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Force Traditional Chinese for school-admin
    if (i18n && i18n.changeLanguage) i18n.changeLanguage('zh-hant');
  }, []);

  return (
  <div className="container-fluid h-100 bg-lighter">
    <div className="row h-100">
      <Router>
        <Nav />
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/school-admin" exact>
                <Redirect to="/school-admin/dashboard" />
              </Route>
              <Route path="/school-admin/dashboard">
                <RouteDashboards />
              </Route>
              <Route path="/school-admin/users">
                <RouteUsers />
              </Route>
              <Route path="/school-admin/schools">
                <RouteSchools />
              </Route>
              <Route path="/school-admin/articles">
                <RouteArticles />
              </Route>
              <Route path="/school-admin/reports">
                <RouteReports />
              </Route>
              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
  );
};

export default SchoolAdmin;
